<template>
     <el-card class="box-card" style="width: 1300px;margin:80px auto 0;">
     <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        style="width:1000px;float:left;margin-bottom:20px;"
      >
          <!-- 循环后端给你的所有题 -->
        <div v-show="showPage">
             <p style="text-align:center;font-size:20px;">
                 <span>
                     总分
                 </span>
                 <span style="color:red;font-weight:700;">
                     {{Allscore}}
                 </span>
             </p>
        </div>
        <div
          class="VSTD_box_item"
          v-for="(item, index) in question"
          :key="index"
        >
           <div v-if="item.index==1" style="margin-top:20px;">
                <h5>
                      二.选择题
                </h5>
           </div>
           <div v-if="item.index==2" style="margin-top:20px;">
                <h5>
                      一.判断题
                </h5>
           </div>
          <div v-for="(item1,index) in item.list" :key="item1.id" class="VSTD_box_item_title">
          <!-- 题目的信息 -->
             <div style="margin-left:20px;">
                 <p style="font-weight: 700">
                  第{{ index + 1 }}题：{{ item1.title
                  }}<span>（{{ item1.score }}分）</span>
                  <span style="color:#66b1ff;margin-left:20px;font-szie:20px;">
                       {{item1.sm}}
                  </span>
                </p>
                <el-radio-group v-if="item.index==1" v-model="ruleForm.resource[index]" @click.native="item1.showAn=true" style="margin-top:15px;">
                      <el-radio disabled="disabled" v-for="item2 in item1.answers" :key="item2.answerid" :label="item2">{{item2.sm}}.{{item2.answerdetail}}</el-radio>
                </el-radio-group>
                 <el-radio-group v-if="item.index==2" v-model="ruleForm.judge[index]" @click.native="item1.showAn=true" style="margin-top:15px;">
                      <el-radio disabled="disabled" v-for="item2 in item1.answers" :key="item2.answerid" :label="item2">{{item2.sm}}.{{item2.answerdetail}}</el-radio>
                </el-radio-group>
                <div v-if="item1.isrw==0">
                     <p style="margin-left:10px;">
                         <span style="color:red;">
                             回答错误
                         </span>
                         <span style="margin-left:10px;">
                             得分:
                             <span style="margin-left:5px;color:red;">{{item1.userscore}}</span>
                         </span>
                     </p>
                    <p style="margin-left:10px;margin-top:10px;">
                        <span style="color:green;">
                            正确答案:
                        </span>
                        <span v-for="item2 in item1.answers" :key="item2.answerid" style="color:green;margin-left:10px;font-szie:16px;">
                            <span v-if="item2.isright==1">{{item2.sm}}</span>
                        </span>
                    </p>
                </div>
                <div v-if="item1.isrw==1">
                     <p style="color:green;">
                         <span>回答正确</span>
                         <span style="margin-left:10px;">
                             得分:<span style="margin-left:5px;color:red;">{{item1.userscore}}</span>
                         </span>
                     </p>
                </div>
             
             </div>
          </div>
        </div>
       </el-form>

  </el-card>
</template>

   

<script>


export default {
    data() {
        return {
           keys:"",
           id:"",
           question:[],
           ruleForm: {
               resource: [],	
                	judge:[],	
           },
           useranser:[],
           showScore:false,
           score:0,
           Allscore:"",
           showPage:false,
        }
    },
    methods:{

    init() {
     this.$http
        .post("Exam/GetSearchList", {
          id:this.id,
          action: "getuserexamxq",
          times:1,
        })
        .then((res) => {
            
          if (res.data.isok) {
           
               this.question = res.data.data
               if(this.question.length>0){
                  this.showPage = true
               }
          }
        })
        .catch((err) => {})
    },
    //代理商提交答案
    submitForm(){      
      
      const that  = this
        that.useranser = []
        that.ruleForm.judge.forEach((item)=>{
               that.useranser.push(item)
        })
           that.ruleForm.resource.forEach((item)=>{
               that.useranser.push(item)
        })
         that.question.forEach((item1)=>{
              item1.list.forEach((item2)=>{
                   item2.answers.forEach((item3)=>{
                        that.useranser.forEach((item4)=>{
                             if(item3==item4){
                                 item4.examid=item2.examid
                                 item4.score=item2.score
                                 item4.inserttime = item2.inserttime
                             }
                             delete item4.sm 
                             delete item4.answerdetail
                             delete item4.isright
                        })
                   })
              })

         })

        that.$http.post("Exam/CommitAnswer",{ 
           useranswer: that.useranser
        }).then((res)=>{
            if(res.data.isok){
                 this.$message.success(res.data.message);
                 this.score = res.data.data
                 this.showScore = true
            }else{
              this.$message.warning(res.data.message);
            }
           
        }).catch((err)=>{})
        
       
    },
   
    

    },
    created(){
         this.id = this.$route.query.id
         this.Allscore =this.$route.query.score
         this.init()
    }
}
</script>


<style scoped>
  .VSTD_box_item_title{
    margin-top:10px;
  }
  .dt_ridio{
       border:1px solid #36d;
       display: inline-block;
       margin-right:5px;
       width:30px;
       height:30px;
       border-radius: 50%;
       text-align: center;
       line-height: 30px;
       font-size:15px;
       cursor: pointer;
  }
  .show_da{
    background-color:#36d;
    color:#fff;
  }
   .el-radio__input.is-disabled+span.el-radio__label {
    color: #000!important;
    cursor: not-allowed;
}
</style>


// WEBPACK FOOTER //
// src/components/AnswerDetail.vue